// user and driver endpoints

import { api } from "api/base";

export const getUser = async () => {
    try {
        const response = await api.get("/auth/user");
        if (response.status === 200) {
            return response.data;
        } else {
            console.log(response);
            return null;
        }

    } catch (error) {
        console.log(error);
        return null;
    }
};

export const getDriver = async () => {
    try {
        const response = await api.get("/auth/driver");
        if (response.status === 200) {
            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.log(error);
        return null;
    }
};

